<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Notificação de Cancelamento (Detalhe)</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioDetalheNotificacaoCancelamento">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field style="margin-top: 6.5px;"
                            class="form-group col-lg-6 col-md-6 col-sm-12 col-12">
                            <mat-label>Msg. para o Paciente</mat-label>
                            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                cdkAutosizeMinRows="2" cdkAutosizeMaxRows="6" formControlName="dscMensagemNotificacao"
                                name="dscMensagemNotificacao" id="dscMensagemNotificacao" maxlength="160"
                                upperCase></textarea>
                        </mat-form-field>

                        <mat-form-field style="margin-top: 6.5px;"
                            class="form-group col-lg-6 col-md-6 col-sm-12 col-12">
                            <mat-label>Motivo do Cancelamento</mat-label>
                            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                cdkAutosizeMinRows="2" cdkAutosizeMaxRows="6" formControlName="dscMotivoNotificacao"
                                name="dscMotivoNotificacao" id="dscMotivoNotificacao" maxlength="255"
                                upperCase></textarea>
                        </mat-form-field>
                    </div>

                    <table mat-table [dataSource]="dataSource" matSort class="table table-striped">
                        <ng-container matColumnDef="nomePessoaNotificacao">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Paciente </th>
                            <td mat-cell *matCellDef="let notificacaoSms"> {{notificacaoSms.nomePessoaNotificacao}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="numTelefone">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Telefone </th>
                            <td mat-cell *matCellDef="let notificacaoSms"> {{notificacaoSms.pk.numTelefone | mask:
                                mascaraFoneCustom(notificacaoSms.pk.numTelefone)}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="table-column-center"> Status </th>
                            <td mat-cell *matCellDef="let notificacaoSms" class="table-column-center">
                                <mat-icon class="mat-18" color="{{notificacaoSms.getCorTipoStatusNotificacao()}}"
                                    style="vertical-align: middle;"
                                    matTooltip="{{notificacaoSms.getTooltipTipoStatusNotificacao()}}">
                                    {{notificacaoSms.getIconeTipoStatusNotificacao()}}
                                </mat-icon>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>


                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes">
                            <button type="button" mat-mini-fab color="primary" (click)="gotoList()" matTooltip="Voltar">
                                <mat-icon>west</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>